import { Input, MultiSearchForm, useDebouncedSearch } from "@";
import { searchValues } from "../utils/options";

const MultiSearch = ({ onSubmit, search, updateSearch }) => {
  // Hook for debounced search
  useDebouncedSearch(onSubmit, search.values, searchValues);

  const handleInputChange = (field, value) => {
    updateSearch({
      values: { ...search.values, [field]: value },
    });
  };

  return (
    <MultiSearchForm
      show={search.show}
      onSubmit={onSubmit}
      className="multi-search-form"
      reset={() => updateSearch({ values: searchValues })}
    >
      {/* Input for searching by title */}
      <Input
        star
        label="كلمة البحث"
        value={search.values.title}
        change={(e) => handleInputChange("title", e.target.value)}
      />

      {/* Input for searching by message status */}
      <Input
        star
        label="حالة الرسالة"
        type="select"
        value={search.values.isSended}
        list={[
          { name: "تم الارسال", value: true },
          { name: "لم يتم الارسال", value: false },
        ]}
        change={(e) => handleInputChange("isSended", e.target.value)}
      />

      {/* Input for searching by date */}
      <Input
        star
        showTimeSelect
        label="التاريخ"
        type="datepicker"
        value={search.values.date}
        change={(e) => handleInputChange("date", e)}
      />
    </MultiSearchForm>
  );
};

export default MultiSearch;
